<script setup lang="ts">

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary } from '@shared/ui/buttons'

import { useModalDisciplineTaskConfirm } from '../../model/modal-discipline-task-confirm.hook'

defineOptions({
  name: 'ModalDisciplineTaskDeclined',
})

const {
  refIsDeclinedOpen,
  refTaskTypeLabel,
  closeModal,
} = useModalDisciplineTaskConfirm()
</script>

<template>
  <ModalDefault
    :show="refIsDeclinedOpen"
    @click:overlay="closeModal"
  >
    <div class="modal-discipline-task-declined">
      <div class="modal-discipline-task-declined__title">
        <AppIcon
          :icon="faCircleExclamation"
          size="big"
          color="red-600"
        />
        <AppText name="h3">
          This task cannot be postponed
        </AppText>
      </div>
      <AppText
        name="body1"
        color="slate-700"
        tag="div"
      >
        Note that we cannot postpone <b>Task {{ refTaskTypeLabel }}</b> - this is the last task for this student.
        Either complete this task for this lesson or contact your manager to explain why this task cannot happen.
      </AppText>
    </div>
    <template #controls>
      <BtnPrimary
        text="Close"
        color="red"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineTaskForm.scss" />
